module.exports = __webpack_public_path__ + "static/img/小雨.483d3083.svg";